import { useMutation } from 'react-query'

import { approvalRoutingRepository } from '@webapp/platform/approval-routing/data-access/repositories/ApprovalRoutingRepository'

export const useMutateEditApprovalPoolSetting = () => {
  const { mutateAsync } = useMutation({
    mutationFn: async ({
      approvalGroupId,
      isPooled,
    }: {
      approvalGroupId: number
      isPooled: boolean
    }) => {
      return await approvalRoutingRepository.setApprovalGroupIsPooled(
        approvalGroupId,
        isPooled
      )
    },
  })

  return { editApprovalPoolSetting: mutateAsync }
}
